module.exports = __webpack_public_path__ + "static/gym-010a033d74ac9dad4f05133e5919b2ad.png";